import {isUnder19, isUnder22} from 'utils/age'

export const isMinorMedicaid = ({
  dob,
  isStudent,
}: {
  dob: Date | null
  isStudent: boolean | null
}) => dob && (isUnder19(dob) || (isUnder22(dob) && isStudent))
